module.exports = __webpack_public_path__ + "static/media/boxes.34944b8b.svg";